import React from 'react';
import {Stack, styled} from '@mui/material';
import {
  Body,
  designSystemToken,
  Headline,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

const EmptyState = styled(Stack)({
  width: '100%',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
});

interface ProjectsEmptyStateProps {
  testID?: string;
}

function ProjectsEmptyState({
  testID = 'projects-empty-state',
}: ProjectsEmptyStateProps) {
  return (
    <EmptyState data-testid={testID} display="flex" flexDirection="column">
      <img src="/assets/svg/projects-empty-state.svg" alt="" />
      <Stack
        direction="column"
        gap="4px"
        alignItems="center"
        justifyContent="center"
      >
        <Headline size="md" color={designSystemToken('semantic.fg.primary')}>
          {translate('No projects yet')}
        </Headline>
        <Body
          size="md"
          color={designSystemToken('semantic.fg.secondary')}
          whiteSpace="pre-wrap"
          textAlign="center"
        >
          {translate(
            'Your recent projects will appear here once you create one.'
          )}
        </Body>
      </Stack>
    </EmptyState>
  );
}

export default ProjectsEmptyState;
